import { useCallback, useEffect, useState } from 'react';
import { apiService } from 'services/service';

const PAGE_LIMIT = 10;

export const useGetSampleRequest = () => {
    const [sampleRequest, setSampleRequest] = useState([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');

    const fetchSampleRequest = useCallback(async ({ page: p = 1, search: q = '' } = {}) => {
        setIsLoading(true);
        try {
            const offset = (p - 1) * PAGE_LIMIT;
            const params = new URLSearchParams({ limit: PAGE_LIMIT, offset });
            if (q) params.set('search', q);
            const res = await apiService.get(`/sample/my?${params.toString()}`);
            setSampleRequest(res?.data ?? []);
            setTotal(res?.total ?? 0);
        } catch (err) {
            console.error('fetchSampleRequest error:', err);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSampleRequest({ page, search });
    }, [fetchSampleRequest, page, search]);

    const goToPage = (p) => setPage(p);
    const onSearch = (q) => {
        setSearch(q);
        setPage(1);
    };
    const refetch = () => fetchSampleRequest({ page, search });

    return {
        sampleRequest,
        total,
        isLoading,
        page,
        search,
        goToPage,
        onSearch,
        refetch,
        PAGE_LIMIT,
    };
};

export const useSampleRequestMutations = () => {
    const [isPending, setIsPending] = useState(false);

    const mutate = useCallback(async (payload) => {
        setIsPending(true);
        try {
            const res = await apiService.post({ url: '/sample', payload });
            return res;
        } finally {
            setIsPending(false);
        }
    }, []);

    return { mutate, isPending };
};
